"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VehicleEncampent = function VehicleEncampent(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("g", {
    clipPath: "url(#clip0)"
  }, _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    d: "M24 5V4H21C20.9343 3.99992 20.8693 4.01282 20.8086 4.03795C20.7479 4.06308 20.6928 4.09995 20.6464 4.14644L15.6464 9.14644C15.5999 9.19282 15.5631 9.24793 15.5379 9.30861C15.5128 9.36928 15.4999 9.43433 15.5 9.5V16.6667H15.5291C15.5635 16.7641 15.6272 16.8485 15.7116 16.9082C15.7959 16.9679 15.8967 16.9999 16 17H16.5C16.5 17.663 16.7634 18.2989 17.2322 18.7678C17.7011 19.2366 18.337 19.5 19 19.5C19.663 19.5 20.2989 19.2366 20.7678 18.7678C21.2366 18.2989 21.5 17.663 21.5 17H24V16H21.291C21.0965 15.5542 20.7761 15.1748 20.3692 14.9084C19.9622 14.6419 19.4864 14.5 19 14.5C18.5136 14.5 18.0378 14.6419 17.6308 14.9084C17.2239 15.1748 16.9035 15.5542 16.709 16H16.5V10H24V9H21.5V5H24ZM19 15.5C19.2967 15.5 19.5867 15.588 19.8334 15.7528C20.08 15.9176 20.2723 16.1519 20.3858 16.426C20.4993 16.7001 20.5291 17.0017 20.4712 17.2926C20.4133 17.5836 20.2704 17.8509 20.0607 18.0607C19.8509 18.2704 19.5836 18.4133 19.2926 18.4712C19.0017 18.5291 18.7001 18.4993 18.426 18.3858C18.1519 18.2723 17.9176 18.08 17.7528 17.8334C17.588 17.5867 17.5 17.2967 17.5 17C17.5005 16.6023 17.6586 16.221 17.9398 15.9398C18.221 15.6586 18.6023 15.5005 19 15.5ZM17.2071 9L20.5 5.70711V9H17.2071Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M3.99981 11H4C4.13261 11 4.25979 10.9473 4.35355 10.8536C4.44732 10.7598 4.5 10.6326 4.5 10.5V6.5C4.5 6.36739 4.44732 6.24021 4.35355 6.14645C4.25979 6.05268 4.13261 6 4 6H0.000166667V7H3.5V10H0V11H3.99981Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M12 4H0V5H12C12.3977 5.00046 12.779 5.15864 13.0602 5.43984C13.3414 5.72105 13.4995 6.10232 13.5 6.5V16H12.5V6.50114C12.5 6.50075 12.5 6.50039 12.5 6.50003C12.5 6.36742 12.4473 6.24024 12.3536 6.14647C12.2598 6.05271 12.1326 6.00003 12 6.00003H8C7.86875 5.9987 7.74234 6.04955 7.64858 6.1414C7.55481 6.23325 7.50137 6.35858 7.5 6.48983C7.5 6.49328 7.50047 6.49661 7.50056 6.50006H7.5V16H6.29103C6.0965 15.5542 5.77614 15.1748 5.36919 14.9084C4.96225 14.642 4.48642 14.5 4.00001 14.5C3.51361 14.5 3.03778 14.642 2.63083 14.9084C2.22389 15.1748 1.90352 15.5542 1.709 16H0V17H1.5C1.5 17.663 1.76339 18.2989 2.23223 18.7678C2.70107 19.2366 3.33696 19.5 4 19.5C4.66304 19.5 5.29893 19.2366 5.76777 18.7678C6.23661 18.2989 6.5 17.663 6.5 17H14C14.1326 17 14.2598 16.9473 14.3536 16.8536C14.4473 16.7598 14.5 16.6326 14.5 16.5V6.5C14.4993 5.83718 14.2356 5.20173 13.767 4.73304C13.2983 4.26436 12.6628 4.00074 12 4ZM4 18.5C3.70333 18.5 3.41332 18.412 3.16664 18.2472C2.91997 18.0824 2.72771 17.8481 2.61418 17.574C2.50065 17.2999 2.47094 16.9983 2.52882 16.7074C2.5867 16.4164 2.72956 16.1491 2.93934 15.9393C3.14912 15.7296 3.41639 15.5867 3.70736 15.5288C3.99834 15.4709 4.29994 15.5007 4.57403 15.6142C4.84811 15.7277 5.08238 15.92 5.2472 16.1666C5.41203 16.4133 5.5 16.7033 5.5 17C5.49955 17.3977 5.34137 17.779 5.06016 18.0602C4.77896 18.3414 4.39769 18.4996 4 18.5ZM8.5 7H11.5V16H8.5V7Z",
    fill: props.foregroundColor
  })), _react.default.createElement("defs", null, _react.default.createElement("clipPath", {
    id: "clip0"
  }, _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};

VehicleEncampent.defaultProps = {
  altText: "Vehicle Encampent",
  backgroundColor: "#00D2D2",
  foregroundColor: "#000000"
};
VehicleEncampent.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = VehicleEncampent;
exports.default = _default;